// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2296":"941c99c6","7930":"21ce4b8c","9577":"2cadd86c"}[chunkId] + ".chunk.css";
};